import type { FC, ReactElement } from 'react';
import { useEffect } from 'react';

import { useRedirectToLobbyCallbackConnected } from '../../../hooks/useRedirectToLobbyCallbackConnected';
import { useCoreDispatch } from '../../../store/CoreStore';
import { usePopupSlice } from '../../../store/slices/popup/selectors';
import { popupActions } from '../../../store/slices/popup/slice';
import { ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import type { BlockingModalActionButton } from './BlockingModalContent';
import { BlockingModalContent } from './BlockingModalContent';

export const PrivateTableOccupiedConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const redirectToLobby = useRedirectToLobbyCallbackConnected();
  const currentPopupData = usePopupSlice.currentPopupData();
  const isPopUpVisible = Boolean(currentPopupData?.popUpInGame);

  useEffect(() => {
    if (isPopUpVisible) {
      const timeoutId = setTimeout(() => {
        redirectToLobby();
      }, 3000); // existing functionality where user needs to be redirected to lobby after 3 sec showing popup

      return (): void => clearTimeout(timeoutId);
    }
  }, [isPopUpVisible]);

  const action: BlockingModalActionButton[] = [
    {
      tk: 'OK',
      type: ButtonVariant.ACCENT,
      click: (): void => {
        if (isPopUpVisible) {
          redirectToLobby();
        } else {
          dispatch(popupActions.dismissPopup(PopupType.PrivateTableOccupied));
        }
      },
    },
  ];

  return <BlockingModalContent titleTk="TABLE_OCCUPIED" messageTk="PRIVATE_OCCUPIED" actions={action} />;
};
